import { render } from "./WjHierarchicalCharts.vue?vue&type=template&id=502d87a0"
import script from "./WjHierarchicalCharts.vue?vue&type=script&lang=js"
export * from "./WjHierarchicalCharts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/cdb5ff5a6ea0682/samples/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__